import { getClaimStatus } from '@/api/processes-api'
import { PbGetWfpClaimByReturnProcessIDRequest } from '@itsrever/rever-api'
import { skipToken, useQuery } from '@tanstack/react-query'

export function useClaimStatus(req: PbGetWfpClaimByReturnProcessIDRequest) {
  return useQuery({
    queryKey: ['claimStatus', req.return_process_id],
    queryFn:
      req.return_process_id !== undefined
        ? () => getClaimStatus({ pbGetWfpClaimByReturnProcessIDRequest: req })
        : skipToken,
    retry: false
  })
}
